import { reportsApi } from '@/api/rtk/reportsApi'
import { shouldAddReportBasedOnFilters } from '@/shared/lib/filters'

function reportBelongsOnTab(report, tabStatus) {
  if (!tabStatus || tabStatus === 'all') return true;
  if (tabStatus === 'urgent') return report?.status === 'urgent' || !!report?.urgent;
  return report?.status === tabStatus;
}

function applyReportToTabDraft(draft, report, { tabStatus, toolName, currentToolFields, filters, search }) {
  if (!draft?.reports) return;

  const index = draft.reports.findIndex((item) => item.id === report.id);
  const belongs = reportBelongsOnTab(report, tabStatus);

  if (index !== -1) {
    if (belongs) {
      draft.reports[index] = { ...draft.reports[index], ...report };
    } else {
      draft.reports.splice(index, 1);
      draft.totalCount = Math.max(0, (draft.totalCount || 0) - 1);
    }
    return;
  }

  if (!belongs) return;
  if (
    !shouldAddReportBasedOnFilters(report, toolName, currentToolFields, {
      filters,
      search,
    })
  ) {
    return;
  }

  draft.reports.unshift(report);
  draft.totalCount = (draft.totalCount || 0) + 1;
}

export function patchReportsListCaches(report, { toolName, currentToolFields } = {}) {
  return (dispatch, getState) => {
    if (!report?.id) return;

    const queries = getState()?.api?.queries || {};
    Object.values(queries).forEach((entry) => {
      if (entry?.endpointName !== 'getReports' || !entry?.originalArgs) return;
      if (entry.status !== 'fulfilled' && !entry.data) return;

      const cacheToolId = entry.originalArgs.toolId;
      if (
        report.tool_id != null &&
        cacheToolId != null &&
        String(cacheToolId) !== String(report.tool_id)
      ) {
        return;
      }

      dispatch(
        reportsApi.util.updateQueryData('getReports', entry.originalArgs, (draft) => {
          applyReportToTabDraft(draft, report, {
            tabStatus: entry.originalArgs.status,
            toolName,
            currentToolFields,
            filters: entry.originalArgs.filters,
            search: entry.originalArgs.search,
          });
        })
      );
    });
  };
}
